import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { Button } from './ui/button';
import { Sparkles, ArrowRight, ShieldCheck } from 'lucide-react';

// V27 — top of the Learn tab for Free / SoulAI-paid learners: book a live prenatal yoga trial class.
export const LiveYogaTrialBanner = () => {
  const navigate = useNavigate();
  const [state, setState] = useState(null);

  useEffect(() => {
    api.get('/api/learner/me').then((r) => setState(r.data?.state || null)).catch(() => {});
  }, []);

  if (!state || !state.trial_classes_available) return null;
  const program = state.trial_program_name || 'Prenatal Yoga';
  const postnatal = program === 'Postnatal Yoga';
  const req = state.trial_request;
  const confirmed = req?.status === 'confirmed';
  // V65 — a trial-paid mom is never invited to pick a slot; the team books her class.
  const withTeam = state.trial_self_booking === false && !confirmed;

  return (
    <section className="relative overflow-hidden rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 via-white to-amber-50 p-5 sm:p-6" data-testid="live-yoga-trial-banner">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-wider text-emerald-700 font-semibold flex items-center gap-1.5"><Sparkles className="h-3.5 w-3.5" />Live {program}</p>
          <h2 className="text-lg md:text-xl font-heading font-semibold mt-1">
            {confirmed ? 'Your trial class is booked' : withTeam ? 'Trial class request received' : 'Try a live class with our instructors'}
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            {confirmed ? `${req.batch_name || program} · ${req.scheduled_date} at ${req.scheduled_time}`
              : withTeam ? 'Our team will get in touch within 24 hours (except Sunday) and book the right class timing for you.'
                : postnatal ? 'Gentle live postnatal recovery classes for new moms. Pick a slot and pay the trial fee — our team confirms your class within 24 hours.'
                  : 'Small live batches matched to your pregnancy. Pick a slot and pay the trial fee — our team confirms your class within 24 hours.'}
          </p>
          {!withTeam && !confirmed && !postnatal && <p className="text-[11px] text-muted-foreground mt-1.5 flex items-center gap-1"><ShieldCheck className="h-3 w-3" />Batches are chosen by risk level and your time zone</p>}
        </div>
        <Button onClick={() => navigate('/learner/trial-classes')} className="shrink-0" data-testid="live-yoga-trial-cta">
          {confirmed || withTeam ? 'View details' : 'See upcoming classes'}<ArrowRight className="h-4 w-4 ml-1.5" />
        </Button>
      </div>
    </section>
  );
};
